import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import {PublicClientApplication} from "@azure/msal-browser";
import {getMsalConfig} from "./aad/authConfig";
import {MsalProvider} from "@azure/msal-react";
import { createRoot } from 'react-dom/client';


const msalInstance = new PublicClientApplication(getMsalConfig(document.location.protocol + "//" + document.location.host));
const container = document.getElementById('root');

const root = createRoot(container!);
root.render(
    <React.StrictMode>
        <MsalProvider instance={msalInstance}>
        <App />
        </MsalProvider>
    </React.StrictMode>,

);




// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
